import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "User Idle";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    company: {
      api: {
        headers: null,
        endpoints: null
      }
    }
  },
  routes: {
    label: null,
    prefix: null
  },
  setup,
  environment
}

export default config;
